import { createSelector } from 'reselect';

import {
    selectCarriersByMode,
    selectMinPriceByCarrier,
} from './carriers';

function selectTravelModes(state, searchParams) {
    const carriersByMode = selectCarriersByMode(state, searchParams) || {};
    return Object.keys(carriersByMode);
}

function _getCheapestCarrierByTravelMode(carriers, travelMode, cheapestByCarrierData) {
    return carriers.reduce((minCarrierId, carrierId) => {
        const minCarrierPrice = cheapestByCarrierData[carrierId][travelMode].USDForSort;
        const min = cheapestByCarrierData[minCarrierId][travelMode].USDForSort;
        if (minCarrierPrice < min) {
            return carrierId;
        }

        return minCarrierId;
    }, carriers[0]);
}

function getCheapestPriceByMode(carriersByModeData, cheapestByCarrierData) {
    return Object.entries(carriersByModeData)
        .reduce((map, [travelMode, carriers]) => {
            const minCarrierId = _getCheapestCarrierByTravelMode(
                carriers,
                travelMode,
                cheapestByCarrierData,
            );

            return {
                ...map,
                [travelMode]: cheapestByCarrierData[minCarrierId][travelMode].pricing,
            };
        }, {});
}

const _selectCheapestPriceByMode = createSelector(
    selectCarriersByMode,
    selectMinPriceByCarrier,
    getCheapestPriceByMode,
);

function mapTravelModes(travelModes, carriersByModeData, cheapestByModeData) {
    return travelModes.reduce((map, travelMode) => {
        const carriers = carriersByModeData[travelMode] || [];
        return {
            ...map,
            [travelMode]: {
                type: travelMode,
                carriers,
                minPricing: cheapestByModeData[travelMode],
            },
        };
    }, {});
}

const selectTravelModesTripData = createSelector(
    selectTravelModes,
    selectCarriersByMode,
    _selectCheapestPriceByMode,
    mapTravelModes,
);

export {
    selectTravelModes,
    selectTravelModesTripData,
};
